const KEY = "urban_passport_notice";
let listeners = [];

export function setPassportNotice(n) {
  try {
    if (n) sessionStorage.setItem(KEY, JSON.stringify(n));
    else sessionStorage.removeItem(KEY);
  } catch { /* noop */ }
  listeners.forEach((l) => l(n));
}

export function getPassportNotice() {
  try { return JSON.parse(sessionStorage.getItem(KEY)); } catch { return null; }
}

export function subscribePassportNotice(fn) {
  listeners.push(fn);
  return () => { listeners = listeners.filter((l) => l !== fn); };
}
